/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Card, Form, InputGroup } from "react-bootstrap";

export default function OrdersAbovePrice({ data }) {
  const [totalAbove, setTotalAbove] = useState(0);
  const [abovePrice, setAbovePrice] = useState(10000);

  const filterData = () => {
    const tempAbove = [];
    data?.forEach((d) => {
      const totalPrice = d.productsRequired.reduce((a, p) => {
        return a + parseInt(p.price.replace(",", ""));
      }, 0);
      if (totalPrice >= abovePrice) {
        tempAbove.push(d);
      }
    });
    setTotalAbove(tempAbove.length);
  };

  useEffect(() => {
    filterData();
  }, []);

  return (
    <Card className="p-2">
      <div className="chart-title2">
        <h2>Orders Above Price</h2>
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Tsh</InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Product group"
            value={abovePrice}
            onChange={(e) => setAbovePrice(e.target.value)}
          />
          <Button variant="success" onClick={filterData}>
            Find
          </Button>
        </InputGroup>
        <h2>{totalAbove} Orders</h2>
      </div>
      <div></div>
    </Card>
  );
}
